export default {
  DebitAccount137: '137',
  DebitAccount814: '814',
  DebitAccount815: '815',
  DebitAccount111: '111',
  DebitAccount1128: '1128',
};
